import * as Redux from 'redux';
import { ReduxPromiseAction, SimpleResponse } from '../app/app.types';
import { callApi } from '../util/ApiCaller';
import { pickAuthOrImpersonationToken } from '../util/token.util';
import { CREATE_PACKAGE, GET_PACKAGES, UPDATE_PACKAGE, GET_PACKAGE_REPORT, DELETE_PACKAGE } from './Constants';
import { PackageActionTypes, PackageResponseData } from './Types';

export const getPackageReport: Redux.ActionCreator<
  ReduxPromiseAction<
    PackageActionTypes, SimpleResponse<PackageResponseData>
  >
> = (year: number, month: number): ReduxPromiseAction<
  PackageActionTypes, SimpleResponse<PackageResponseData>
> => ({
  type: GET_PACKAGE_REPORT,
  payload: callApi(
    process.env.REACT_APP_API + '/package/report/' + year + '/' + month,
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const deletePackage: Redux.ActionCreator<
  ReduxPromiseAction<
    PackageActionTypes, SimpleResponse<PackageResponseData>
  >
> = (id: number): ReduxPromiseAction<
  PackageActionTypes, SimpleResponse<PackageResponseData>
> => ({
  type: DELETE_PACKAGE,
  payload: callApi(
    process.env.REACT_APP_API + '/package/' + id,
    true,
    {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});

export const createPackage: Redux.ActionCreator<
  ReduxPromiseAction<
    PackageActionTypes, SimpleResponse<PackageResponseData>
  >
> = (
  id: number, 
  description: string, 
  memberId: number,
  purchaseDate: number,
  expiryDate: number,
  totalClasses: number,
  paymentId?: number
): ReduxPromiseAction<
  PackageActionTypes, SimpleResponse<PackageResponseData>
> => ({
  type: CREATE_PACKAGE,
  payload: callApi(
    process.env.REACT_APP_API + '/package',
    true,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({
        id, 
        description, 
        memberId,
        purchaseDate,
        expiryDate,
        totalClasses,
        paymentId
      })
    }
  )
});

export const updatePackage: Redux.ActionCreator<
  ReduxPromiseAction<
    PackageActionTypes, SimpleResponse<PackageResponseData>
  >
> = (
  id: number, 
  description: string, 
  memberId: number,
  purchaseDate: number,
  expiryDate: number,
  totalClasses: number,
  paymentId?: number
): ReduxPromiseAction<
  PackageActionTypes, SimpleResponse<PackageResponseData>
> => ({
  type: UPDATE_PACKAGE,
  payload: callApi(
    process.env.REACT_APP_API + '/package',
    true,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      },
      body: JSON.stringify({
        id, 
        description, 
        memberId,
        purchaseDate,
        expiryDate,
        totalClasses,
        paymentId
      })
    }
  )
});

export const getPackages: Redux.ActionCreator<
  ReduxPromiseAction<
    PackageActionTypes, SimpleResponse<PackageResponseData>
  >
> = (): ReduxPromiseAction<
  PackageActionTypes, SimpleResponse<PackageResponseData>
> => ({
  type: GET_PACKAGES,
  payload: callApi(
    process.env.REACT_APP_API + '/package/list',
    true,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': pickAuthOrImpersonationToken()
      }
    }
  )
});



// WEBPACK FOOTER //
// ./src/mms-package/Actions.tsx